import { VETERAN_STATUS_CODES } from 'helpers/constants/aafes';

export const isVeteranAccount = (account: any) => {
  return VETERAN_STATUS_CODES?.includes(account?.statusCode);
};
